define(function (require, exports) {
    'use strict';
    var sdkinit = require('XmSdk');
    // @ngInject
    exports.metCard = function (TEMPLATE_PATH) {
        return {
            restrict: 'E',
            scope: {
                startjourney: '=?startjourney',
                request: '=?request',
                submit: '&submit'
            },

            controller: /* @ngInject */ function ($scope, $timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication, metroContext, metroTagging, metroMeta) {

                $scope.showPaymentModal = true;
                $scope.currentStep = "step1";
                $scope.lastpayment = false;
                $scope.secondaryUser = false;
                $scope.isItemMgmt = false;
                $scope.confirmLoading = false;

                $scope.cancelStepUp = function (isCancel) {

                    /* GA Tagging COB-SCA-BA005*/
                    if($scope.type){
                        metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                            metroMeta.EVENTACTION.sca,
                            isCancel ? 'cancel authorisations: yes cancel request' : eventDetailString($scope.isItemMgmt ? 'Item management' : 'accounts', $scope.type),
                            metroMeta.EVENT.buttonAction);
                    }

                    if (isCancel || $scope.lastpayment) {
                        window.localStorage.setItem('cards_sca_modal', 'true');
                    }
                    $scope.show = false;
                    $scope.currentStep = 'step1';
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }

                $scope.endStepUp = function (jwt, error) {
                    if(jwt=="registration"){
                        return true;
                    }
                    $scope.show = true;
                    if (jwt === 'cancel') {
                        $scope.stepUpObject.startjourney = false;
                        $scope.show = true;
                        $scope.currentStep = 'step1';
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    } else {
                        if (!error) {
                            /* Card approve journey  COB-SCA-G004*/
                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                                $scope.type == "PA" ? metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHAPPROVAL : metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHCARDAPPROVAL,
                                metroMeta.TRANSMIT.SCA.CARDAPPROVALJOURNEYCOMPLETEDDETAIL,
                                metroMeta.EVENT.goal);
                            
                            startTransmitJourney('transaction_accept_decline', {
                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
                                "authenticationResult": "Success",
                                "requestId": $scope.transactions[$scope.currentTransaction].requestID
                            });
                        } else {
                            $scope.show = true;
                            $scope.confirmLoading = false;
                            if (error && error[0].responseCode === "LOGIN_GENERIC") {
                                displayError('cardsgeneric_' + $scope.type);
                            } else {
                                displayError(error);
                            }

                        }
                    }
                }

                $scope.stepUpObject = {
                    startjourney: false,
                    request: {},
                    endjourneyfirst: $scope.endStepUp
                }

                $scope.typeOnAmount = function (type, amt) {
                    if (type === 'NPA') {
                        if (amt + '' === '0' || amt === '0.00' || amt === 0.00) {
                            return 'NPA';
                        } else {
                            return 'PA';
                        }
                    } else {
                        return 'PA';
                    }
                }

                $scope.setHeader = function (type) {
                    $scope.type = type;
                    if (type == "PA") {
                        $scope.modalHeader = "Authorise online payments";
                    }
                    else {
                        $scope.modalHeader = "Authorise your card";
                    }
                }

                $scope.needHelp = function () {
                    /* GA Tagging COB-SCA-BA005*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase() + ": help",
                        metroMeta.EVENT.buttonAction);

                    $scope.toggleHelp = !$scope.toggleHelp;
                }

                $scope.setSubtitle = function () {
                    var paymenttypes = {}
                    if ($scope.transactions.length > 0) {
                        for (var i = 0; i < $scope.transactions.length; i++) {
                            var type = $scope.typeOnAmount($scope.transactions[i].authentication.type, $scope.transactions[i].transaction.amount)
                            paymenttypes[type] = (paymenttypes[type] == undefined) ? 1 : parseInt(paymenttypes[type]) + 1;
                        }

                        if ((paymenttypes.PA && paymenttypes.PA > 0) && (paymenttypes.NPA && paymenttypes.NPA > 0)) {
                            $scope.subtitle = "Authorisation"
                        }
                        else if (paymenttypes.PA && paymenttypes.PA > 0) {
                            $scope.subtitle = "Payment"
                        }
                        else if (paymenttypes.NPA && paymenttypes.NPA > 0) {
                            $scope.subtitle = "Authorisation"
                        }
                        else {
                            $scope.subtitle = ""
                        }
                    }
                }

                var showApproved = function () {
                    $scope.show = true;
                    $scope.messages = null;

                    if ($scope.type === "NPA") {
                        $scope.cardStatus = {
                            message: "Approved",
                            header: "Approved card addition - what to do next",
                            description: "Please return to the seller's website to complete adding your card."
                        };
                    }
                    else {
                        $scope.cardStatus = {
                            message: "Approved",
                            header: "Approved payment - what to do next",
                            description: "Please return to the seller's website to complete your approved payment."
                        };
                    }
                    /* Card approve journey  COB-SCA-G005*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                        $scope.modalHeader.toLowerCase()+": approval",
                        metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDWITHRESULTDETAIL,
                        metroMeta.EVENT.goal);
                        $scope.currentStep = 'step2';
                        $scope.modalHeader = "Thank you, almost there!";

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
                
                var showDeclined = function () {
                    $scope.show = true;
                   
                    $scope.messages = null;
                    if ($scope.type === "PA") {
                        $scope.cardStatus = {
                            message: "Declined",
                            header: "Declined payment - what to do next",
                            description: "If you don't recognise this payment, please contact us immediately on the details below. If you declined a payment by mistake, you can now return to seller's website and make the payment again."
                        }
                    } else {
                        $scope.cardStatus = {
                            message: "Declined",
                            header: "Declined card addition - what to do next",
                            description: "If you didn’t make this request, please contact us straightaway on the details below. If you declined it by mistake, please return to the seller’s website and add the card again."
                        };
                    }

                    /* Card approve journey  COB-SCA-G009*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                        $scope.modalHeader.toLowerCase()+": decline",
                        metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDWITHRESULTDETAIL,
                        metroMeta.EVENT.goal);
                    
                    $scope.modalHeader = "Thank you, almost there!";
                    $scope.currentStep = 'step2';

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }

                $scope.transactions = [];
                $scope.currentTransaction;
                var startTransmitJourney = function (journey, object) {
                    metroTransmit.invokePolicy(journey, object, null).then(function (response) {
                        if (journey === "retrieve_transactions_cob") {
                            if (response._internalData.json_data && response._internalData.json_data &&
                                response._internalData.json_data.authentications && response._internalData.json_data.authentications.length > 0) {

                                $scope.show = true;
                                $scope.transactions = response._internalData.json_data.authentications;
                                $scope.setSubtitle();
                                $scope.currentTransaction = 0;
                                $scope.lastpayment = ($scope.currentTransaction + 1 === $scope.transactions.length);

                                $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));
                                if (!$scope.$$phase) {
                                    $scope.$apply();
                                }
                                metroTagging.onpageLoadTag(
                                    'Card Ecommerce | Metrobank',
                                    document.location.pathname + "/modal-ecommerce-card/"+($scope.type=='PA'?'payment':'card'),
                                    metroMeta.EVENT.pageLoaded);

                                /* Card approve journey  COB-SCA-G001*/
                                metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                                    $scope.modalHeader.toLowerCase(),
                                    metroMeta.TRANSMIT.CARDS.JOURNEYSTARTEVENTDETAIL,
                                    metroMeta.EVENT.goal);

                            } else {
                                if (response._internalData.json_data && response._internalData.json_data.length === 0) {
                                    $scope.cancelStepUp();
                                    window.localStorage.setItem('cards_sca_modal', 'true');
                                }
                            }
                        }

                        if (journey === "transaction_accept_decline") {
                            if (response._internalData.json_data && response._internalData.json_data.data) {
                                $scope.confirmLoading = false;
                                $scope.lastpayment = ($scope.currentTransaction + 1 === $scope.transactions.length);
                                if (response._internalData.json_data.data.transaction_action_successful) {
                                    if (object.authenticationResult === "Success") {
                                        showApproved();
                                    } else {
                                        showDeclined();
                                    }
                                    
                                } else {
                                    displayHighrisk();
                                }

                                metroTagging.onpageLoadTag(
                                    'Card Ecommerce | Metrobank',
                                    document.location.pathname + "/modal-ecommerce-card/"+(object.authenticationResult == "Success" && response._internalData.json_data.data.transaction_action_successful ?'approved-':'declined-')+($scope.type === "PA"?'payment':'card')+"/thankyou",
                                    metroMeta.EVENT.pageLoaded);

                                if (!$scope.$$phase) {
                                    $scope.$apply();
                                }
                            }
                        }

                    }).catch(function (err) {
                        console.log(err);
                        var error = err._data;
                        $scope.confirmLoading = false;

                        if (error && error.failure_data && error.failure_data.reason) {
                            displayError('tysys_failure_'+$scope.type);
                            $scope.isTysysError = true;
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                        } else {
                            displayError('cardsgeneric_' + $scope.type);
                        }

                        /* Card approve journey  COB-SCA-N001*/
                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification,
                            metroMeta.EVENTACTION.popup,
                            ($scope.modalHeader ? $scope.modalHeader.toLowerCase() : 'card stepup journey') + ": somethings wrong try again",
                            metroMeta.EVENT.notification);
                    });
                }

                var displayHighrisk = function () {
                    $scope.approvalFlag = 'Declined';
                    $scope.isHighRisk = true;
                    $scope.type = $scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount);
                    if ($scope.type === "NPA") {
                        $scope.cardStatus = {
                            message: "Declined",
                            header: "Your card addition has been declined",
                            description: "To keep you safe we've had to decline this request"
                        };
                    } else {
                        $scope.cardStatus = {
                            message: "Declined",
                            header: "Your transaction has been declined",
                            description: "To keep you safe we've had to decline this payment"
                        };
                    }
                    $scope.currentStep = 'step2';
                    $scope.messages = metroTransmit.handleError('transmit_high_risk');
                    $scope.modalHeader = null;
                    $scope.focusTop('errortemp')



                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }

                }

                $scope.$watch('startjourney', function (newValue) {
                    if (newValue) {
                        startTransmitJourney("retrieve_transactions_cob", {}, null);
                        $scope.isItemMgmt = (window.location.href.indexOf('item-management') >= 0) ? true : false;
                        //$scope.secondaryUser = true;
                        //lpCoreBus.publish('secondary-user');

                    }
                });

                $scope.submitForm = function () {

                    /* GA Tagging COB-SCA-BA004*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase() + ": confirm payment",
                        metroMeta.EVENT.buttonAction);

                    if ($scope.approvalFlag) {
                        $scope.confirmLoading = true;
                        if ($scope.approvalFlag === 'Declined') {
                            startTransmitJourney('transaction_accept_decline', {
                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
                                "authenticationResult": "UserCanceled",
                                "requestId": $scope.transactions[$scope.currentTransaction].requestID
                            });

                            /* Card approve journey  COB-SCA-G006*/
                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                                $scope.modalHeader.toLowerCase()+": decline",
                                metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDDETAIL,
                                metroMeta.EVENT.goal);

                        } else {
                            $scope.stepUpObject.request = {
                                "business_flow": 'card',
                                "sub_flow_type1": 'transaction',
                                "sub_flow_type2": $scope.transactions[$scope.currentTransaction].authentication.type,
                                "sub_flow_type3": '',
                                "customer_operation": 'approve',
                                'ben_account_number': '', //card number
                                'payment_amount': '',
                                "payment_ccy": '',
                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
                                'payment_id': '',
                                'trusted_ben': '',
                                'requestId': $scope.transactions[$scope.currentTransaction].requestID,
                                "authenticationResult": "Success",
                                'isScaCards': true,
                                'isPA': $scope.type === 'PA',
                                "isMultipleTransaction": $scope.transactions.length > $scope.currentTransaction + 1
                            }
                             /* Card approve journey  COB-SCA-G002*/
                             metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                                $scope.modalHeader.toLowerCase()+": approval",
                                metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDDETAIL,
                                metroMeta.EVENT.goal);

                            lpCoreBus.subscribe('hide-cards-modal', function () {
                                $scope.confirmLoading = false;
                                $scope.show = false;
                                if (!$scope.$$phase) {
                                    $scope.$apply();
                                }
                            })
                            $scope.stepUpObject.startjourney = true;
                        }
                    } else {
                        displayError('approvalunselected');
                        /* Card approve journey  COB-SCA-N001*/
                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification,
                            metroMeta.EVENTACTION.inline,
                            $scope.modalHeader + ": Please select an option",
                            metroMeta.EVENT.notification);
                    }
                }
                //To do :  Retest this functionlity : Accessiblity
                $scope.focusTop = function (focusElement) {
                    if (document.getElementById('errortemp')) {
                        $('.modal-content').animate({
                            scrollTop: $('#' + focusElement).css('top')
                        }, 800)
                        document.getElementById('errortemp').focus();
                    }
                    //var customerNoElement = angular.element('.'+focusElement);
                };

                

                $scope.cancelProcess = function () {
                    /* GA Tagging  COB-SCA-BA003*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        eventDetailCancelString("cancel"),
                        metroMeta.EVENT.buttonAction);
                    if($scope.currentStep == "step2" && !$scope.lastpayment){
                        $scope.currentTransaction = $scope.currentTransaction + 1;
                    }

                    $scope.approvalFlag = "";
                    if($scope.messages && $scope.messages[0].responseCode != 'tysys_failure'){
                       $scope.messages = null;
                    }
                    $scope.currentStep = "cancelTransactions";
                    $scope.modalHeader = "Cancel authorisations";

                    metroTagging.onpageLoadTag(
                        'Card Ecommerce | Metrobank',
                        document.location.pathname + "/modal-ecommerce-card/"+($scope.type=='PA'?'payment':'card')+"/cancel",
                        metroMeta.EVENT.pageLoaded);

                }

                $scope.logout = function () {
                    /* GA Tagging COB-SCA-BA009*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        eventDetailString('log out', $scope.type),
                        metroMeta.EVENT.buttonAction);

                    lpUsersAuthentication.logOut();
                }

                var eventDetailString = function (value, trasactionType) {
                    var eventDetail;
                    if ($scope.approvalFlag == 'Declined' && trasactionType == 'PA') {
                        eventDetail = metroMeta.TRANSMIT.CARDS.DECLINEDPAYMENT + ": " + value
                    }
                    else if ($scope.approvalFlag == 'Approved' && trasactionType == 'PA') {
                        eventDetail = metroMeta.TRANSMIT.CARDS.APPROVEDPAYMENT + ": " + value
                    }
                    else if ($scope.approvalFlag == 'Declined' && trasactionType == 'NPA') {
                        eventDetail = metroMeta.TRANSMIT.CARDS.DECLINECARD + ": " + value
                    }
                    else if ($scope.approvalFlag == 'Approved' && trasactionType == 'NPA') {
                        eventDetail = metroMeta.TRANSMIT.CARDS.APPROVEDCARD + ": " + value
                    }
                    return eventDetail;
                }

                var eventDetailCancelString = function (value) {
                    var eventDetail;
                    if ($scope.currentStep == "step1" || $scope.currentStep == "cancelTransactions") {
                        eventDetail = $scope.modalHeader.toLowerCase()+": " + value
                    }
                    else { //($scope.currentStep == "step2"
                        console.log("console.log")
                        eventDetail = $scope.cardStatus.header.toLowerCase().split(" - ")[0].toLowerCase()+": " + value
                    }

                    return eventDetail;
                }


                
                $scope.nextPayment = function () {
                    
                   $scope.messages = null;
                   $scope.isTysysError = false;
                   $scope.isHighRisk = false;
                   var currentTrasactionType = angular.copy($scope.type);
                   $scope.lastpayment = ($scope.currentTransaction + 1 === $scope.transactions.length);
                   !$scope.lastpayment ? ($scope.currentTransaction = $scope.currentTransaction + 1):'';
                   $scope.currentStep = "step1";
                   $scope.toggleHelp = false;
                   $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));

                   /* GA Tagging COB-SCA-BA009 */
                   metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                    metroMeta.EVENTACTION.sca,
                    eventDetailString(($scope.type == 'PA' ? 'go to next payment' : 'go to next authorisation'), currentTrasactionType),
                    metroMeta.EVENT.buttonAction);

                   /* Card approve journey COB-SCA-G006 */
                   metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                       ($scope.type == "PA" ? "authorise online payments": "authorise your card"),
                       metroMeta.TRANSMIT.CARDS.JOURNEYSTARTEVENTDETAIL,
                       metroMeta.EVENT.goal);

                   $scope.approvalFlag = null;
                   if (!$scope.$$phase) {
                       $scope.$apply();
                   }
               }

                $scope.goBack = function () {
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase() + ": no go back",
                        metroMeta.EVENT.buttonAction);

                    if ($scope.approvalFlag && !$scope.lastpayment && $scope.currentStep == "step2") {
                        $scope.nextPayment();
                    }
                    $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));
                    $scope.toggleHelp = false;
                    $scope.currentStep = "step1";

                }

                $scope.approvalFlag = null;
                $scope.approval = function (value) {
                    /* GA Tagging  COB-SCA-BA001 & COB-SCA-BA002*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase() + ": " + (value == "Approved" ? 'approve' : 'decline'),
                        metroMeta.EVENT.buttonAction);

                    $scope.approvalFlag = value;
                    $scope.messages = null;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
                var displayError = function (errorType) {
                    $scope.messages = metroTransmit.handleError(errorType);
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    $scope.focusTop('errortemp')
                }

            },
            templateUrl: TEMPLATE_PATH + 'metCard.html'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metCard.js